import React from "react"
import "./Text.scss"

class TextEvent extends React.Component {
  render(){
    return (
      <div className="text-event">
        <div className="title">
          Eventos
        </div>
      </div>
    )
  }
}

export default TextEvent
